"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSupplyList = void 0;
const Base_1 = require("./Base");
exports.GetSupplyList = {
    url: Base_1.URL_BASE + "/GetSupplyList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetSupplyList.js.map